import React from 'react';

const SvgArrows24 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M9.31 6.545a.5.5 0 0 1 .54.105l3 2.996a.509.509 0 0 1 0 .708l-3 2.996a.5.5 0 0 1-.85-.36V7a.5.5 0 0 1 .31-.455zm7.761-3.616A10 10 0 0 1 20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0a10 10 0 0 1 7.071 2.929zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgArrows24 svgRef={ref} {...props} />);
export default ForwardRef;
